import CaseStudyCard from './CaseStudyCard';

export default CaseStudyCard;



// WEBPACK FOOTER //
// ./src/components/shared/CaseStudyCard/index.js